module.exports = __webpack_public_path__ + "img/img1.81b5537a.jpg";